import { useEffect } from 'react'
import { FilterBar } from '../FilterBar'
import { Box, Flex } from '@workwhile/ui'
import { usePulseContext } from 'pages/PulsePage/context/PulseProvider'
import { EmptyState } from '../EmptyState'
import { SpendMetrics } from './SpendMetrics'
import { SpendTimeseries } from './SpendTimeseries'
import { SpendByLocation } from './SpendByLocation'
import { SpendPerWorkerTimeseries } from './SpendPerWorkerTimeseries'
import { PayRateByLocation } from './PayRateByLocation'
import { PayRateMarketByLocation } from './PayRateMarketByLocation'
import { PayRateTimeseries } from '../Operations/PayRateTimeseries'
import { PayRateMetrics } from './PayRateMetrics'
import { track } from 'lib/amplitude'

export function CostMain() {
  const {
    state: { filters },
  } = usePulseContext()

  useEffect(() => {
    track('impression, pulse_page_cost', {
      filters,
    })
  }, [])

  return (
    <Box>
      <FilterBar />
      {filters.companyIds.length > 0 ? (
        <Flex flexDirection="column" gap={5} pb={4}>
          <SpendMetrics />
          <SpendTimeseries />
          <SpendByLocation />
          <SpendPerWorkerTimeseries />
          <PayRateMetrics />
          <PayRateTimeseries />
          <PayRateByLocation />
          <PayRateMarketByLocation />
        </Flex>
      ) : (
        <EmptyState />
      )}
    </Box>
  )
}
